// extracted by mini-css-extract-plugin
export default {"mainDiv":"Faq_mainDiv__S+XRY","faqsr":"Faq_faqsr__jGh+7","faq":"Faq_faq__pINf-","box":"Faq_box__3-Gp4"};